"use strict";

export function initInScope($scope){
    const allowedAttibutes = window._config.findologicFilter;
    let allAttributes = [];
    $('.js-quick-filter').html('');

    allowedAttibutes.map((item, index) => {
        if (item.type == 'range-slider'){
            allAttributes.push(item.name+'[min]');
            allAttributes.push(item.name+'[max]');
        } else if (item.type == 'select' || item.type == 'label'){
            allAttributes.push(item.name+'[]');
        }
    });

    allAttributes.map((item, index) => {
        createButtons(item);
    });
}

function createButtons(item){
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const urlData = urlParams.getAll(item);
    urlData.map((itemSub) => {
        createButton(itemSub, item);
    })
}

function createButton(item, key){
    const button = document.querySelector('.js-quick-filter__template').children[0];
    let buttonClone = button.cloneNode(true);

    let text = item.replace(/_/g, ' > ');
    let rangeCounterpart = false;
    switch(key){
        case 'price[min]':
            text = 'von '+formatPrice(parseInt(item), _config.lang, 'currency', 'EUR', 'symbol');
            //rangeCounterpart = 'price[max]';
            break;
        case 'price[max]':
            text = 'bis '+formatPrice(parseInt(item), _config.lang, 'currency', 'EUR', 'symbol');
            //rangeCounterpart = 'price[min]';
            break;
    }

    buttonClone.querySelector('.js-quick-filter__text').innerHTML = text;
    buttonClone.querySelector('.js-quick-filter__text').setAttribute('data-text-origin', item.replace(/&/g, '_AND_'));
    buttonClone.querySelector('.js-quick-filter__item').setAttribute('data-key', key);
    buttonClone.querySelector('.js-quick-filter__item').setAttribute('data-range-counterpart', rangeCounterpart);
    buttonClone.addEventListener('click', (e) => {
            $(e.target).closest("form").submit();
            removeButton(buttonClone, e)
    });

    $('.js-quick-filter').append(buttonClone);

    $('.js-quick-filter__title').addClass('show');
    $('.js-quick-filter__remove-all').removeAttr('hidden');
    $('.js-quick-filter__remove-all').unbind().on({
        click:function(){
            removeAllFilter($(this)[0]);
        }
    });

    /*
    let decodeHTML = function (html) {
    let txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
    };
    findIn(selectors.text, newButtonElement).innerHTML = decodeHTML(inputState.text);
    return newButtonElement;
    */
}

function removeButton(button){
    let locationSearch = window.location.search.replace('?', '');
    if (button.querySelector('.js-quick-filter__item').getAttribute('data-range-counterpart')){
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        urlParams.delete(button.querySelector('.js-quick-filter__item').getAttribute('data-range-counterpart'));
        window.sessionStorage.removeItem(button.querySelector('.js-quick-filter__item').getAttribute('data-range-counterpart'));
        locationSearch = `${urlParams}`;
    }

    // encodeURI
    window.sessionStorage.removeItem(button.querySelector('.js-quick-filter__item').getAttribute('data-key'));
    let url = decodeURI(window.location.pathname+'?'+locationSearch+location.hash).replace(/%26/g, '_AND_');
    url = url.replace('&'+button.querySelector('.js-quick-filter__item').getAttribute('data-key')+'='+button.querySelector('.js-quick-filter__text').getAttribute('data-text-origin').replace(/ /g, '+'), '');
    window.location.href = encodeURI(url);
}

function removeAllFilter(){
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    Array.from(document.querySelectorAll('.js-quick-filter__item')).map((item, index) => {
        urlParams.delete(item.getAttribute('data-key'));
        window.sessionStorage.removeItem(item.getAttribute('data-key'));
    });
    window.location.href = `${window.location.pathname}?${urlParams}${window.location.hash}`;
}

export function formatPrice(amount, locale, style, currency, currencyDisplay){
    let string = amount.toLocaleString(locale, {
        style:style || 'decimal',
        currencyDisplay:currencyDisplay || 'symbol',
        currency:currency
    });
    return string;
}